// App-wide toast helpers, wrapping react-toastify so callers don't import the
// library directly. The <ToastContainer/> is mounted once in App.js.
//
// Usage:
//   import { toastError, toastSuccess, toastInfo } from '../../lib/toast';
//   toastError('Submit failed.');
//   toastSuccess('App request submitted.');
import { toast } from 'react-toastify';

const BASE = {
  position: 'top-right',
  autoClose: 4000,
  pauseOnHover: true,
  closeOnClick: true,
};

export function toastSuccess(message, opts = {}) {
  return toast.success(message, { ...BASE, ...opts });
}

export function toastError(message, opts = {}) {
  // Errors linger a touch longer and don't auto-dismiss as eagerly.
  return toast.error(message, { ...BASE, autoClose: 6000, ...opts });
}

export function toastInfo(message, opts = {}) {
  return toast.info(message, { ...BASE, ...opts });
}

export function toastWarning(message, opts = {}) {
  return toast.warning(message, { ...BASE, autoClose: 6000, ...opts });
}

/**
 * Pull a human message out of an axios error, falling back to a default.
 * Server returns `{ error: 'some_code' }`; callers can pass a code→text map.
 */
export function errorMessage(err, fallback = 'Something went wrong. Try again.', map = {}) {
  const code = err?.response?.data?.error;
  if (code && map[code]) return map[code];
  if (typeof code === 'string' && code.length && code.length < 80) {
    // Turn snake_case codes into readable text as a last resort.
    return map[code] || fallback;
  }
  return fallback;
}
